// Generated by CoffeeScript 2.7.0
var AutomationVertexConfig;

import RefuseCheckBox from 'trunks/vue/admin/components/modals/refuse_check_box.js';

import VertexConfig from './base.js';

export default AutomationVertexConfig = Vue.extend({
  extends: VertexConfig,
  components: {
    'refuse-check-box': RefuseCheckBox
  },
  template: `<div class="config-container">
  <tabs navsClass='nav secondary config-nav'>
    <tab name='节点基础属性' tabKey='basic'>
      <div class="config-item">
        <div class="config-item-content">
          <div class="list settings-list">
            <div class="list-item">
              <div class="tip">节点名称</div>
              <div class="content">
                <input type="text" v-model.trim='vertex.name' placeholder='节点名称' />
              </div>
            </div>
            <div class="list-item">
              <div class="tip">节点别名</div>
              <div class="content">
                <input type="text" v-model.trim='vertex.alias_name' placeholder='节点别名' />
              </div>
            </div>
            <div class="list-item">
              <div class="tip">URL</div>
              <div class="content">
                <input type="text" v-model.trim='vertex.automation_agent.webhook_url' placeholder='机器人地址' />
              </div>
            </div>
            <div class="list-item">
              <div class="tip">Secret</div>
              <div class="content">
                <input type="text" v-model.trim='vertex.automation_agent.webhook_secret' placeholder='机器人密钥' />
              </div>
            </div>
          </div>
        </div>
      </div>
      <user-boundary-comp :userBoundary='vertex.cc_user_boundary'
                      title='抄送'
                      :extraBoundaryComps='ccUserBoundaryCompOptions'
                      @valueChanged='ccUserBoundaryChangeFunc' />

      <div class="config-item">
        <div class="config-item-title justify-box">
          <span class="content text-ellipsis">回传字段</span>
          <popover-field-select extendClass='field-select-popover'
                                :formatDataFunc='formatDataFunc'
                                :initialSelectedOptionIds='vertex.field_ids'
                                @submitClicked="updateVertexFields"
                                ref='fieldSelectRef'>
            <template slot='trigger'>
              <i class="slp-link-o"></i>
            </template>
            <template slot='option-item-template' slot-scope='{ option }'>
              <div class="content text-ellipsis">
                <i :class="_fieldIcon(option)"></i>
                <span>{{ option.name }}</span>
              </div>
              <i class="tip" :class="option._selected ? 'slp-check' : 'slp-empty'"></i>
            </template>
            <div slot='filter-blankslate' class="list-group-name">没有能引用的回传字段</div>
            <div slot='options-blankslate' class="list-group-name">没有能引用的回传字段</div>
          </popover-field-select>
        </div>
        <div class="config-item-content">
          <div class="list-group" v-for='group in selectedFields'
               :key='group.id'>
            <div class="list-group-name">{{ group.name }}</div>
            <div class="list">
              <div class="list-item" v-for='option in group.options'
                   :key='option.id'>
                <div class="content text-ellipsis">
                  <i :class="_fieldIcon(option)"></i>
                  <span>{{ option.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </tab>
    <tab name='更多属性' tabKey='additional'>
      <div class="config-item">
        <div class="config-item-content">
          <div class="list settings-list">
            <div class="list-item">
              <div class="tip">处理人别名</div>
              <div class="content">
                <input type="text" v-model.trim='vertex.settings.processor_alias_name' placeholder='处理人别名' />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="config-item">
        <div class="config-item-title">操作者按钮</div>
        <div class="config-item-content">
          <div class="list operations-list">
            <operation-btn-checkbox :button='vertex.operations.refuse'
                                    type='refuse' />
            <refuse-check-box :refuseMode="vertex.settings.refuse_mode"
                              :refuseReviewersMode="vertex.settings.refuse_reviewers_mode"
                              @refuseModeChanged="refuseModeChangedFunc"
                              @refuseReviewersModeChanged="refuseReviewesModeChangedFunc"/>
          </div>
        </div>
      </div>
    </tab>
  </tabs>
</div>`,
  computed: {
    operationsButtons: function() {
      return _.pick(this.vertex.operations, 'comment');
    }
  },
  methods: {
    refuseModeChangedFunc: function(val) {
      return this.vertex.settings.refuse_mode = val;
    },
    refuseReviewesModeChangedFunc: function(val) {
      return this.vertex.settings = {
        ...this.vertex.settings,
        refuse_reviewers_mode: val
      };
    }
  },
  mounted: function() {
    if (this.vertex.isAutomation) {
      return this.$watch('vertex.automation_agent', _.debounce(function() {
        return this.updateVertex();
      }, 1000), {
        deep: true
      });
    }
  }
});
